module.exports = __webpack_public_path__ + "static/media/llamame.a2e2b95c.png";